import PropTypes from 'prop-types';
import React from 'react';
import TruncateMarkup from 'react-truncate-markup';

class EllipsisBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            renderContent: this.renderContent(),
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = e => {
        this.setState({ renderContent: '' });
        setTimeout(() => {
            this.setState({ renderContent: this.renderContent() });
        });
    };

    renderContent = () => {
        const { content, maxLine, ...rest } = this.props;

        return (
            <TruncateMarkup lines={maxLine} {...rest}>
                {content}
            </TruncateMarkup>
        );
    };

    render() {
        const { renderContent } = this.state;

        return renderContent;
    }
}

EllipsisBlock.propTypes = {
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    maxLine: PropTypes.number,
};

EllipsisBlock.defaultProps = {
    content: '',
    maxLine: 3,
};

export default EllipsisBlock;
